module.exports = __webpack_public_path__ + "static/media/Emer-bannerweb-6.cb32d340.png";